import { ThumbsUp, ThumbsDown, ArrowLeft, ArrowRight } from 'lucide-react'
import React, { useState, memo } from 'react'
import { Button } from '@/components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import styles from '@/styles/NodeDocument.module.css'
import MarkdownRenderer from '../markdown-renderer/MarkdownRenderer'

interface SectionReviewPanelProps {
  sectionId: string
  originalContent: string
  suggestedContent: string
  commandType: string
  onAccept: () => void
  onReject: () => void
}

const SectionReviewPanel: React.FC<SectionReviewPanelProps> = ({
  sectionId,
  originalContent,
  suggestedContent,
  commandType,
  onAccept,
  onReject,
}) => {
  const [activeViewTab, setActiveViewTab] = useState(0)

  // Prevent event propagation to avoid triggering section selection
  const handleAccept = (e) => {
    e.stopPropagation()
    console.log(`Accept button clicked for section ${sectionId}`)
    onAccept()
  }

  const handleReject = (e) => {
    e.stopPropagation()
    console.log(`Reject button clicked for section ${sectionId}`)
    onReject()
  }

  return (
    <div className="section-review-panel" onClick={(e) => e.stopPropagation()}>
      <h4 style={{ marginTop: '8px', marginBottom: '12px', color: '#555' }}>
        Review {commandType} Changes
      </h4>

      <div
        style={{
          gap: '12px',
          marginBottom: '12px',
        }}
      >
        {/* Suggested content - now with tabs for raw and preview */}
        <div>
          <h5 style={{ margin: '4px 0', fontSize: '14px', color: '#666' }}>
            Suggested Changes:
          </h5>

          <Tabs defaultValue="preview" className="w-full">
            <TabsList className="grid grid-cols-2">
              <TabsTrigger value="preview">Preview</TabsTrigger>
              <TabsTrigger value="raw">Raw</TabsTrigger>
            </TabsList>

            <TabsContent value="preview">
              <div
                className={`p-4 border rounded-md bg-background ${styles.markdownPreview}`}
              >
                <MarkdownRenderer markdown={suggestedContent} />
              </div>
            </TabsContent>

            <TabsContent value="raw">
              <div className="p-4 border rounded-md bg-background">
                <pre
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily: 'monospace',
                    fontSize: '12px',
                    margin: 0,
                    textAlign: 'left',
                  }}
                >
                  {suggestedContent}
                </pre>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>

      <div className="flex justify-between mt-4">
        <div className="flex space-x-2">
          <Button
            variant="outline"
            onClick={handleReject}
            className="text-destructive"
          >
            <ThumbsDown className="mr-2 h-4 w-4" />
            Reject
          </Button>
          <Button
            variant="outline"
            onClick={handleAccept}
            className="text-success"
          >
            <ThumbsUp className="mr-2 h-4 w-4" />
            Approve
          </Button>
        </div>
      </div>
    </div>
  )
}

export default memo(SectionReviewPanel)
